import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/bookassignment/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/bookassignment/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.bookassignment.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveBookAssignmentAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC, vo });

            EditService.saveBookAssignment(
                vo,
                response => {
                    dispatch(Actions.saveBookAssignmentSuccess(response));
                },
                error => {
                    dispatch(Actions.saveBookAssignmentFailure(error));
                }
            );
        };
    },

    saveBookAssignmentSuccess: data => ({
        type: ActionTypes.SAVE_BOOK_ASSIGNMENT_SUCCESS,
        parentType: ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC,
        data
    }),

    saveBookAssignmentFailure: error => ({
        type: ActionTypes.SAVE_BOOK_ASSIGNMENT_FAILURE,
        parentType: ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC,
        error
    }),

    selectCourseType: courseType => ({
        type: ActionTypes.SELECT_COURSE_TYPE,
        courseType
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    bookAssignment: null,
    courses: null,
    courseTypes: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, bookAssignment: data.bookAssignment, courses: data.courses, courseTypes: data.courseTypes };
};

const selectCourseTypeReducer = (state, { courseType }) => {
    return { ...state, bookAssignment: { ...state.bookAssignment, course: { ...state.bookAssignment.course, type: courseType } } };
}

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_BOOK_ASSIGNMENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_BOOK_ASSIGNMENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SELECT_COURSE_TYPE]: selectCourseTypeReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
